import React, { useEffect, useState } from 'react';
import IPageProps from '../../interfaces/page';
import { currentClass, devTolPrint, downloadImage, getLoginInfo, loadCtrlAndDisable, ReacherArPictureName_before } from './tool/helper';
import { IGroupForExpertS, IGroupInfo } from '../../interfaces/EpModal';
import TopNavPage1 from '../topNav1';
import FooterPage from '../footer';
import ExpertFunctionBar from './component/expertFunctionBar';
import { getAllDrGroup } from '../../services/EP/EpExpertService';
import { PageIndexX } from '../../components/pageIndexX';
import LoadingScreen from './tool/LoadingScreen';
import { checkFileExists } from '../../services/DrFileService';
type ImageStatus = 'ok' | 'broken' | 'missing';
// https://attendance-67917bb.web.app/digit/epStudHome.html
const EpExpertGroup: React.FunctionComponent<IPageProps> = () => {
    const [currentLoginInfo, setCurrentLoginInfo] = useState<any>();
    const [imageErrors, setImageErrors] = useState<{ [key: string]: boolean }>({});
    const [groupForExpertList, setGroupForExpertList] = useState<IGroupForExpertS[]>();
    /** 下拉式選單 */
    const [selectSectionList, setSelectSectionList] = useState<IGroupForExpertS[]>();
    const [groupForExpertDisplayList, setGroupForExpertDisplayList] = useState<IGroupForExpertS[]>([]);
    const [selectedClassName, setSelectClassName] = useState<string>();
    const [selectedGroup, setSelectedGroup] = useState<string>();
    const [selectedGroupSet, setSelectedGroupSet] = useState<string>();
    const [dropDownExport, setDropDownExport] = useState<{ expAccount: string; groupset: string; exportName: string }[]>([]);
    const [selectedExpert, setSelectedExpert] = useState<{ expAccount: string; groupset: string; exportName: string }>();
    const [selectedSchoolName, setSelectedSchoolName] = useState<string>('(全部學校)');
    const [displayAmount, setDisplayAmount] = useState<number>(1000);
    /**下拉選單 【班級】*/
    const [classNameList, setClassNameList] = useState<string[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    /** 下拉選單 【小組】*/
    const [groupList, setGroupList] = useState<string[]>([]);
    /** 下拉選單 【學校】 */
    const [schoolNameList, setSchoolNameList] = useState<string[]>([]);

    const [lCurrentPage1, setLCurrentPage1] = useState(1);
    const pageName = '小隊基本資料 ';

    const [missingImages, setMissingImages] = useState<string[]>([]);
    const [pdfStatusMap, setPdfStatusMap] = useState<Record<string, boolean>>({});
    const handleImageError = async (src: string) => {
        try {
            const response = await fetch(src, { method: 'HEAD' });
            console.log('sss', JSON.stringify(response));
            if (response.ok) {
                // 有這個圖片檔案，但無法顯示 → 檔案毀損
                setImageStatusMap((prev) => ({ ...prev, [src]: 'broken' }));
            } else {
                // 圖片檔案不存在
                setImageStatusMap((prev) => ({ ...prev, [src]: 'missing' }));
            }
        } catch (error) {
            // 連 HEAD 請求都失敗 → 也當作毀損
            setImageStatusMap((prev) => ({ ...prev, [src]: 'broken' }));
        }
    };

    useEffect(() => {
        loadCtrlAndDisable(sessionStorage.getItem('role') || 'guest', pageName);
    }, []);
    useEffect(() => {
    const fetchPDFStatuses = async () => {
        const map: Record<string, boolean> = {};
        for (const item of groupForExpertDisplayList) {
            const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
            const rsp = await checkFileExists(`/uploads/upload${currentClass}/${item.Groupno}`, 'FinalReport.pdf', '');
            map[pdfPath] = rsp === '檔案已存在.';
        }
        setPdfStatusMap(map);
    };
    fetchPDFStatuses();
}, [groupForExpertDisplayList]);
    useEffect(() => {
        fetchdataGroupInfo();
    }, []);

    const [imageStatusMap, setImageStatusMap] = useState<Record<string, ImageStatus>>({});
    const [imageStatusMap2, setImageStatusMap2] = useState<Record<string, boolean>>({});
    const [isPictureExist, setIsPictureExist] = useState(false);

    // useEffect(() => {
    //     // alert("selectedGroup" +JSON.stringify(selectedGroup))
    //     getIsFileExist();
    // }, [selectedGroup]);

    useEffect(() => {
        const fetchStatuses = async () => {
            const map: Record<string, boolean> = {};
            for (const item of groupForExpertDisplayList) {
                const imagePath = `/uploads/upload${currentClass}/${item.Groupno}/${ReacherArPictureName_before}`;
                const exists = await getIsFileExist(item.Groupno);
                map[imagePath] = exists;
            }
            setImageStatusMap2(map);
        };

        fetchStatuses();
    }, [groupForExpertDisplayList]);

    const getIsFileExist = async (groupNo: string) => {
        const rsp = await checkFileExists(`/uploads/upload${currentClass}/${groupNo}`, ReacherArPictureName_before, '');
        return rsp === '檔案已存在.';
        // alert(`/uploads/upload${currentClass}/${selectedGroup?.groupNo}`)
        if (rsp === '檔案已存在.') {
            setIsPictureExist(true);
        } else {
            setIsPictureExist(false);
        }
    };

    // 選擇的變動時開始塞選
    useEffect(() => {
        setFilterData();
    }, [selectedClassName, selectedGroup, selectedSchoolName, selectedExpert]);

    // 選擇的變動時開始塞選
    useEffect(() => {
        reloadDropDownExport();
    }, [selectedClassName]);

    const reloadDropDownExport = () => {
        let exportlist: { expAccount: string; groupset: string; exportName: string }[] = [];
        let temp: IGroupForExpertS[] = groupForExpertList?.filter((i) => i.Class === selectedClassName) || [];
        exportlist.push({ expAccount: '', groupset: '(全部)', exportName: '回饋組別' });
        temp.forEach((i) => {
            if (!exportlist.find((x) => x.expAccount === i.exportAccount)) exportlist.push({ expAccount: i.exportAccount, groupset: i.GroupSet, exportName: i.ExpertName });
        });

        setDropDownExport(exportlist);
        if (exportlist.length > 0) setSelectedExpert(exportlist[0]);
    };

    const setFilterData = (target?: string) => {
        let result: IGroupForExpertS[] = groupForExpertList || [];
        // 處理年度
        result =
            groupForExpertList?.filter((item) => {
                return selectedClassName?.trim() === item.Class.trim();
            }) || [];
        if (selectedExpert?.exportName !== '回饋組別') {
            result = result.filter((item) => {
                return selectedExpert?.groupset?.trim() === item.GroupSet.trim();
            });
        }

        if (selectedSchoolName !== '(全部學校)' && selectedSchoolName && selectedSchoolName.length > 0) {
            result = result.filter((item) => {
                return selectedSchoolName?.trim() === item.Schoolname.trim();
            });
        }

        // 處理

        setGroupForExpertDisplayList(result);
        setDisplayAmount(result.length);
    };

    const handleImageError2 = (groupNo: string) => {
        // setImageErrors((prev) => ({
        //   ...prev,
        //   [groupNo]: true,
        // }));
    };

    const fetchdataGroupInfo = async () => {
        /** 取得登入資料 */
        let currentLoginInfo = getLoginInfo();
        setCurrentLoginInfo(currentLoginInfo);

        try {
            let classNameList: string[] = [];
            let groupNameList: string[] = [];
            let groupSetList: string[] = [];
            // groupNameList.push('全部組別');
            let schoolNameList: string[] = [];
            setIsLoading(true);
            let rsp = (await getAllDrGroup()) as IGroupForExpertS[];
            // 處理下拉式選單
            rsp.forEach((item) => {
                if (!classNameList.includes(item.Class)) {
                    // 設定年度
                    classNameList.push(item.Class);
                }
                if (!groupNameList.includes(item.Groupname)) {
                    groupNameList.push(item.Groupname);
                }

                if (!groupSetList.includes(item.GroupSet)) {
                    groupSetList.push(item.GroupSet);
                }
                if (!schoolNameList.includes(item.Schoolname)) schoolNameList.push(item.Schoolname);
            });
            setClassNameList(classNameList);
            setSelectClassName(classNameList[0]);
            setGroupList(groupNameList);

            setSelectedGroupSet('回饋組別');
            setSchoolNameList(schoolNameList);
            setSelectedGroup('回饋組別');

            setGroupForExpertList(rsp);
            setIsLoading(false);
            console.log('取得專家的隊伍', rsp);
        } catch (error) {}
        // const groupInfo
    };

    useEffect(() => {
        getGroupNoList();
    }, [selectedClassName]);

    const getGroupNoList = () => {
        let result: IGroupForExpertS[] =
            groupForExpertList?.filter((item) => {
                return item.Class === selectedClassName;
            }) || [];

        setSelectSectionList(result);
        setSelectedGroup('回饋組別');
        setSelectedGroupSet('回饋組別');
        setSelectedSchoolName('(全部學校)');
    };

    const renderSchoolOptions = () => {
        const uniqueSchools = [...new Set(selectSectionList?.map((item) => item.Schoolname))];

        return uniqueSchools.map((school) => (
            <li>
                <div className="dropdown-item sel-active" onClick={() => setSelectedSchoolName(school)}>
                    {school}
                </div>
            </li>
        ));
    };
    /** 專家 欄位2 */
    const renderExpertOption = () => {
        const uniqueExperts = [...new Set(selectSectionList?.map((item) => item.GroupSet + '-' + item.ExpertName))];
        if (uniqueExperts.length > 0) {
            //  setSelectedExpert(uniqueExperts[0])
        }

        return dropDownExport.map((expert) => (
            <li>
                <div className="dropdown-item sel-active" onClick={() => setSelectedExpert(expert)}>
                    {expert.groupset}-{expert.exportName}
                </div>
            </li>
        ));
    };

    const exportToHTML = () => {
        const newWindow = window.open('', '_blank');

        if (!newWindow) return;

        newWindow.document.write(`
          <html>
            <head>
              <meta charset="UTF-8">
              <title>資料匯出</title>
              <style>
                table, th, td {
                  border: 1px solid black;
                  border-collapse: collapse;
                  padding: 5px;
                  text-align: center;
                }
              </style>
            </head>
            <body>
              <h2>小隊清單</h2>
              <table>
                <tr>
                  <th>No.</th>
                  <th>回饋組別</th>
                  <th>小隊編號</th>
                  <th>小隊名稱</th>
                  <th>學校</th>
                  <th>縣市</th>
                  <th>鄉鎮區</th>
                  <th>題目</th>
                  <th>通過</th>
                  <th>圖片-回饋前</th>
               
                </tr>
        `);
        groupForExpertDisplayList.forEach((item, index) => {
            const imagePath = `/uploads/upload${currentClass}/${item.Groupno}/${ReacherArPictureName_before}`;
            const hasImage = imageStatusMap2[imagePath]; // 你原本邏輯中的 status2

            const imageOrText = hasImage
                ? `<img src="${imagePath}" width="100" height="40" onerror="this.outerHTML=&quot;<div style='color:red;'>顯示失敗</div>&quot;">`
                : `<div style="color:gray">📭 尚未上傳</div>`;

            newWindow.document.write(`
              <tr>
                <td>${index + 1}</td>
                <td>${item.GroupSet}</td>
                <td>${item.Groupno}</td>
                <td>${item.Groupname}</td>
                <td>${item.Schoolname}</td>
                <td>${item.City}</td>
                <td>${item.Area}</td>
                <td>${item.Topic?.replace(/<[^>]*>?/gm, '') || ''}</td>
                <td>${item.FlagOK ? '√' : '--'}</td>
                <td>${imageOrText}</td>

              </tr>
            `);
        });
        newWindow.document.write(`
              </table>
            </body>
          </html>
        `);

        newWindow.document.close();
    };

    if (isLoading) {
        return <LoadingScreen />;
    }

    return (
        <>
            <TopNavPage1 />
            <div className="section pt-3">
                <div className="container px-3 px-md-4">
                    <div className="d-flex align-items-center justify-content-between flex-column flex-lg-row">
                        <h5 className="title mb-3 me-3">專題探究競賽</h5>

                        <ExpertFunctionBar />
                    </div>
                    <div className="text-center h5 mt-4 mb-3">小隊基本資料查詢</div>

                    {/* {JSON.stringify(groupForExpertDisplayList)} */}
                    <div className="d-flex flex-wrap justify-content-center align-items-center mb-4">
                        <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedClassName}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                {classNameList.map((item) => (
                                    <li>
                                        <div className="dropdown-item sel-active" onClick={() => setSelectClassName(item)}>
                                            {item}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedGroupSet}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <div className="dropdown-item sel-active">
                                        <b>回饋組別</b>
                                    </div>
                                </li>
                                {selectSectionList?.map((item) => (
                                    <li>
                                        <div className="dropdown-item sel-active" onClick={() => setSelectedGroupSet(item.GroupSet)}>
                                            {item.GroupSet}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div> */}

                        <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedExpert?.groupset + '' + selectedExpert?.exportName}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                {renderExpertOption()}
                            </ul>
                        </div>

                        <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                            <button className="btn text-second bg-second dropdown-toggle mb-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ minWidth: '180px' }}>
                                {selectedSchoolName}
                            </button>
                            <ul className="dropdown-menu px-2 py-3" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <div className="dropdown-item sel-active" onClick={() => setSelectedSchoolName('(全部學校)')}>
                                        <b>(全部學校)</b>
                                    </div>
                                </li>

                                {renderSchoolOptions()}
                            </ul>
                        </div>
                    </div>

                    <div className="card p-4 pt-3" style={{ width: '1350px', overflow: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button className="btn text-second bg-second mb-2" onClick={exportToHTML}>
                                匯出 HTML（含圖片）
                            </button>
                        </div>
                        共 {groupForExpertDisplayList?.length} 筆
                        <div className="d-flex align-items-end ms-auto">
                            <div className="text-second">顯示筆數</div>
                            <div className="dropdown mx-2" style={{ width: 'fit-content' }}>
                                <button className="btn dropdown-toggle fs-16 mb-0 py-0 px-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {displayAmount} 筆
                                </button>

                                {/* <div className="alert alert-warning mt-3">
          有 {missingImages.length} 張圖片載入失敗：
          <ul>
            {missingImages.map((path, i) => (
              <li key={i}>{path}</li>
            ))}
          </ul>
        </div> */}
                                <ul className="dropdown-menu py-3" aria-labelledby="dropdownMenuButton">
                                    {[
                                        { display: '10筆', number: 10 },
                                        { display: '20筆', number: 20 },
                                        { display: '50筆', number: 50 },
                                        { display: '100筆', number: 100 },
                                        { display: '全部', number: groupForExpertDisplayList.length }
                                    ].map((item) => (
                                        <li>
                                            <div className="dropdown-item sel-active" onClick={() => setDisplayAmount(item.number || 1000)}>
                                                {item.display}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="table-responsive  " style={{ width: '1300px', height: '500px', overflow: 'auto' }}>
                            {/* {devTolPrint(imageStatusMap2)} */}
                            <table className="text-sm table table-striped mb-0">
                                <thead>
                                    <tr className="font-weight-bolder text-second" style={{ background: '#d9dce6' }}>
                                        <th className="p-2 text-nowrap">No.</th>
                                        <th className="p-2 text-nowrap" style={{ width: '60px', minWidth: '20px', maxWidth: '60px' }}>
                                            回饋組別
                                        </th>
                                        <th className="p-2 text-nowrap">小隊編號</th>
                                        <th className="p-2 text-nowrap" style={{ width: '120px', minWidth: '80px', maxWidth: '120px' }}>
                                            小隊名稱
                                        </th>
                                        <th className="p-2 text-nowrap" style={{ width: '80px', minWidth: '80px', maxWidth: '80px' }}>
                                            學校
                                        </th>
                                        <th className="p-2 text-nowrap">縣市</th>
                                        <th className="p-2 text-nowrap">鄉鎮區</th>
                                        <th className="p-2 text-nowrap" style={{ width: '180px', minWidth: '120px', maxWidth: '180px' }}>
                                            題目
                                        </th>
                                        <th className="p-2 text-nowrap">通過</th>
                                        <th className="p-2 text-nowrap">備註</th>
                                        {/*  */}
                                        <th className="p-2 text-nowrap">架構圖</th>
                                            <th className="p-2 text-nowrap">成果報告</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupForExpertDisplayList.slice((lCurrentPage1 - 1) * displayAmount, lCurrentPage1 * displayAmount).map((item, index) => {
                                        const imagePath = `/uploads/upload${currentClass}/${item.Groupno}/${ReacherArPictureName_before}`;
                                        const status = imageStatusMap[imagePath];
                                        const status2 = imageStatusMap2[imagePath];
                                        // const isExist  =  getIsFileExist (item.Groupno)
                                        return (
                                            <tr>
                                                <td>
                                                    {index + 1}
                                                    {status}
                                                </td>
                                                <td style={{ width: '60px', minWidth: '50px', maxWidth: '60px' }}>{item.GroupSet}</td>
                                                <td style={{ width: '120px', minWidth: '80px', maxWidth: '120px' }}>{item.Groupno}</td>
                                                <td>{item.Groupname}</td>
                                                <td style={{ width: '80px', minWidth: '80px', maxWidth: '80px' }}>{item.Schoolname} </td>
                                                <td>{item.City}</td>
                                                <td>{item.Area} </td>
                                                <td style={{ width: '200px', minWidth: '120px', maxWidth: '200px', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: item.Topic }}></div>
                                                    {/* <div>動物排泄物與腸道的關係</div>
                                                  <div>動物排泄物與腸道的關係與因素</div> */}
                                                </td>
                                                <td> {item.FlagOK ? '√' : '--'} </td>
                                                <td></td>
                                                <td>
                                                    {/* {item.Groupno} */}

                                                    {!status2 && <div className="text-muted">📭 尚未上傳</div>}
                                                    {/* {!status && <div className="text-muted">📭 檔案毀損</div>} */}
                                                    {/* {status2 && !imageErrors[item.Groupno] && (     */}

                                                    {status2 && <img className="imgs" src={imagePath} width={50} height={20} alt="" onError={() => handleImageError2(item.Groupno)} />}

                                                    {/* {status2 && <img className="imgs" src={imagePath} width={50} height={20} alt="" />} */}
                                                </td>

              <td>
    {(() => {
        const pdfPath = `/uploads/upload${currentClass}/${item.Groupno}/FinalReport.pdf`;
        const hasPDF = pdfStatusMap[pdfPath];
        if (hasPDF === undefined) {
            return <span className="text-muted">載入中...</span>;
        } else if (hasPDF) {
            return <a href={pdfPath} target="_blank" rel="noopener noreferrer">查看報告</a>;
        } else {
            return <span className="text-muted">📭 無檔案</span>;
        }
    })()}
</td>
                                            </tr>
                                        );
                                    })}

                                    {/* <tr>
                                        <td>2</td>
                                        <td>A</td>
                                        <td>EB003-03</td>
                                        <td>B.E.L.K好奇寶寶團 </td>
                                        <td>臺南大學附小 </td>
                                        <td>臺南市</td>
                                        <td>中西區 </td>
                                        <td>
                                            <div>動物也會鳩佔鵲巢？-外來種的分析與探討</div>
                                            <div>動物也會鳩佔鵲巢-外來種的分析與探討</div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                        <PageIndexX frameSize={displayAmount} pageSize={displayAmount} totalRec={groupForExpertDisplayList?.length} currentPage={lCurrentPage1} setCurrentPage={setLCurrentPage1} />
                    </div>

                    <div className="pt-3 mt-4"></div>
                </div>
            </div>

            <FooterPage />
        </>
    );
};

export default EpExpertGroup;
